import axios from 'axios'

// Get all transactions for admin
const getAll = async (iniDate, endDate) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/transaction/admin/${iniDate}/${endDate}`)
  return data
}

// Refund transaction
const refund = async (transaction, reason) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/signature/payment/refund/`, { transaction, reason })
  return data
}

// Create transaction manually (admin)
const create = async (user, product, amount, date, createSignature) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/transaction/admin`, {
    user,
    product,
    amount,
    date,
    createSignature
  })
  return data
}

export {
  getAll,
  refund,
  create
}
